import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./index.module.scss";
import { BaseImage } from "../BaseImage";
import { getImagePath } from "@/util/imgUtil/url";
import { NewBaseIcon } from "../NewBaseIcon";
import { hsbToRgb } from "@/util/index";
import { compressImage } from "@/util/imgUtil";
const BaseAvatarV2 = param => {
  let {
    size = 44,
    imageSrc,
    name,
    textSize,
    userId,
    className,
    style,
    triggerIcon,
    bottomRightIcon,
    hasHover = false,
    hasMask = false,
    onClick
  } = param;
  /**
  * @param imgSrc 获取头像图片完整链接
  * @returns
  */
  const getUserAvatarUrl = imgSrc => {
    if (!imgSrc) return;
    if (imgSrc === "-") {
      return "-";
    } else if (/^https?|^data:image/.test(imgSrc)) {
      return imgSrc;
    } else {
      return getImagePath("userAvatar", imgSrc);
    }
  };
  /**
  * @param name 根据名称获取展示的首字母，支持emoji符号显示
  * @returns
  */
  const getInitials = name => {
    //@ts-ignore
    const regex = RegExp("\\p{Emoji}", "u");
    const match = name.match(regex);
    if (match) {
      // 如果字符串包含emoji表情符号，直接返回匹配到的表情符号
      return match[0];
    }
    // 否则，返回字符串的第一个字符，并转为大写
    return name.trim()[0].toUpperCase();
  };
  /**
  * @param userId 根据userId生成0-360范围内的随机数，颜色取值范围 H: 0-360 （随机取数）S: 75 B: 90
  * @returns
  */
  const getBackgroundColor = userId => {
    if (!userId) {
      return "rgb(249, 250, 251)";
    }
    const prime = 2027;
    const num = parseInt(userId.slice(-10)) || 1;
    const hash = num * prime % 361;
    const rgb = hsbToRgb(hash, 75, 90);
    const [r, g, b] = rgb;
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
  };
  const renderContent = () => {
    if (imageSrc && imageSrc !== "-") {
      return /*#__PURE__*/_jsx(BaseImage, {
        src: compressImage(getUserAvatarUrl(imageSrc) || "", {
          resize: "500"
        }),
        alt: "avatar",
        className: styles.base_avatar
      });
    } else {
      return /*#__PURE__*/_jsx("span", {
        className: classNames(styles.base_avatar, styles.base_avatar_with_name),
        style: {
          backgroundColor: getBackgroundColor(userId || "") || "rgb(242, 244, 247)",
          fontSize: "".concat(textSize ? textSize : size / 2, "px")
        },
        children: name && getInitials(name)
      });
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classNames({
      [styles.avatar_container]: true,
      [styles.mask_container]: hasMask,
      [styles.mask_hasHover]: hasHover,
      className
    }),
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      ...style
    },
    onClick: onClick,
    children: [renderContent(), hasMask && /*#__PURE__*/_jsx("div", {
      className: styles.avatar_mask,
      children: triggerIcon
    }), bottomRightIcon && /*#__PURE__*/_jsx("div", {
      className: styles.br_icon,
      children: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: bottomRightIcon,
        size: 12
      })
    })]
  });
};
export default BaseAvatarV2;